module.exports = __webpack_public_path__ + "img/expositor.19af7326.png";